import {ErrorMessage, Field} from 'formik';
import {useTranslation} from 'react-i18next';

import {Box, Grid, Typography} from '@mui/material';

import building_icon from '../../../../../../../../../assets/job_postings/icons/building-columns-icon.png';
import {
  EmpionSelectField,
  EmpionSelectFieldOption,
} from '../../../../../../../../../components/EmpionSelectField/EmpionSelectField';

interface HardFactsFieldsDegreeProps {
  options: EmpionSelectFieldOption[];
}

export const HardFactsFieldsDegree = ({options}: HardFactsFieldsDegreeProps) => {
  const {t} = useTranslation();

  return (
    <Grid
      item
      xs={12}
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box width={'100%'} display={'flex'} alignItems={'center'} gap={'8px'}>
        <Box component='img' src={building_icon} alt='building_icon' />
        <Field
          type='select'
          name='degree'
          label={`${t('companyJobPostings.newJobDialog.formLabels.degree')}*`}
          component={EmpionSelectField}
          options={options}
          size={'small'}
          fullWidth
        />
      </Box>
      <Box ml={3}>
        <Typography variant='body2' color='error'>
          <ErrorMessage name='degree' component='span' />
        </Typography>
      </Box>
    </Grid>
  );
};
